// 收付款 关联 订单金额
<template>
  <div class="clearfix choose-match-invoice">
    <div class="sel-modal-header clearfix">
      <vxe-radio-group v-model="tabVal" size="medium">
        <ul class="tab-list">
          <li>
            <vxe-radio name="xtabs" label="new">新订单2.0</vxe-radio>
          </li>
          <li v-if="isSub">
            <vxe-radio name="xtabs" label="sub">附属订单</vxe-radio>
          </li>
        </ul>
      </vxe-radio-group>
      <div class="my-search" v-show="tabVal === 'new'">
        <vxe-input
            v-model="searchOrdersNum"
            style="width: 150px"
            type="text"
            placeholder="输入订单编号"
            @keyup.enter.native="search"
            clearable
        ></vxe-input>
        <vxe-input
            v-model="searchOrdersName"
            type="text"
            placeholder="输入订单标题"
            @keyup.enter.native="search"
            style="width: 150px; margin-left: 10px"
            clearable
        ></vxe-input>
        <Select
            v-model="searchOrdersBuyer"
            filterable
            prefix="ios-arrow-down"
            clearable
            :remote-method="
            file =>
              remoteMethod(
                file,
                'buyerNameOptions',
                'twoOrders',
                'searchCondition',
                3
              )
          "
            :default-label="[]"
            :loading="searchLoading"
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="
            file => setDefaultOptions(file, 'buyerNameOptions')
          "
            placeholder="输入托运人名称"
            @keyup.enter.native="search"
            style="width: 150px; margin-left: 10px"
        >
          <Option
              v-for="option in buyerNameOptions"
              :value="option.name"
              :key="option.name"
          >{{ option.name }}
          </Option>
        </Select>
        <Select
            v-model="searchOrdersSeller"
            filterable
            prefix="ios-arrow-down"
            clearable
            :remote-method="
            file =>
              remoteMethod(
                file,
                'sellerNameOptions',
                'twoOrders',
                'searchCondition',
                4
              )
          "
            :default-label="[]"
            :loading="searchLoading"
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="
            file => setDefaultOptions(file, 'sellerNameOptions')
          "
            placeholder="输入承运人名称"
            @keyup.enter.native="search"
            style="width: 150px; margin-left: 10px"
        >
          <Option
              v-for="option in sellerNameOptions"
              :value="option.name"
              :key="option.name"
          >{{ option.name }}
          </Option>
        </Select>
        <vxe-input
            v-model="searchOrdersSaleMan"
            type="text"
            placeholder="输入业务员"
            @keyup.enter.native="search"
            style="width: 150px; margin-left: 10px"
            clearable
        ></vxe-input>
        <Button type="primary" icon="ios-search" @click="search" style="margin-left: 10px;border-radius: 4px;">搜索
        </Button>
      </div>
      <div class="my-search" v-show="tabVal === 'sub'">
        <vxe-input v-model="ordersNumAttached" style="width: 150px" type="text" placeholder="输入订单编号"
                   @keyup.enter.native="search2" clearable></vxe-input>
        <vxe-input v-model="ordersTitleAttached" type="text" placeholder="输入订单标题" @keyup.enter.native="search2"
                   style="width: 150px; margin-left: 10px" clearable></vxe-input>
        <Select
            v-model="searchComp"
            multiple
            filterable
            clearable
            :default-label="[]"
            :loading="searchLoading"
            :remote-method="
                      (file) =>
                        remoteMethod(file, 'compOptions', 'twoOrders', 'queryAttachedOrderKeyword', 6)
                    "
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="(file) => setDefaultOptions(file, 'compOptions')"
            placeholder="输入所属公司"
            style="width: 200px; margin-left: 10px"
        >
          <Option v-for="option in compOptions" :value="option.id" :key="option.id"
          >{{ option.text }}
          </Option>
        </Select>
        <Select
            v-model="searchSellerName"
            multiple
            filterable
            clearable
            :default-label="[]"
            :loading="searchLoading"
            :remote-method="
                      (file) =>
                        remoteMethod(file, 'sellerOptions', 'twoOrders', 'queryAttachedOrderKeyword', 2)
                    "
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="(file) => setDefaultOptions(file, 'sellerOptions')"
            placeholder="输入销售方"
            style="width: 200px; margin-left: 10px"
        >
          <Option v-for="option in sellerOptions" :value="option.id" :key="option.id"
          >{{ option.text }}
          </Option>
        </Select>
        <Select
            v-model="searchSalesMan"
            multiple
            filterable
            clearable
            :default-label="[]"
            :loading="searchLoading"
            :remote-method="
                      (file) =>
                        remoteMethod(file, 'salesManOptions', 'twoOrders', 'queryAttachedOrderKeyword', 3)
                    "
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="(file) => setDefaultOptions(file, 'salesManOptions')"
            placeholder="输入业务员"
            style="width: 200px; margin-left: 10px"
        >
          <Option v-for="option in salesManOptions" :value="option.id" :key="option.id"
          >{{ option.text }}
          </Option>
        </Select>
        <Button type="primary" icon="ios-search" @click="search2" style="margin-left: 10px;border-radius: 4px;">搜索
        </Button>
      </div>
    </div>

    <div class="add-box clearfix" v-show="tabVal === 'new'">
      <vxe-table
          show-overflow
          stripe
          highlight-current-row
          border="none"
          class="table-style"
          ref="xTable1"
          max-height="450"
          :auto-resize="true"
          :loading="loading1"
          :data="tableData"
          align="center"
          @current-change="currentChangeEvent1"
      >
        <vxe-table-column field="ordersNum" title="订单编号" width="130">
          <template slot-scope="{ row }">
            <a @click="openOrderDetail(row.id)">{{ row.ordersNum }}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="aboutAmount" title="关联金额" width="150"
                          v-if="!isEdit && !controlEdit"></vxe-table-column>
        <vxe-table-column field="ordersTitle" title="订单标题" width="150"></vxe-table-column>
        <vxe-table-column field="ordersState" title="订单状态" width="100">
          <template slot-scope="{ row }">
            <span>{{ row.ordersState | ordersStateMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="buyerName" title="托运人" width="150" align="center">
        </vxe-table-column>
        <vxe-table-column field="compName" title="平台企业" width="200"></vxe-table-column>
        <vxe-table-column field="sellerName" title="承运人" width="150" align="center"></vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="105" align="center">
        </vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="75" align="center">
        </vxe-table-column>
        <vxe-table-column field="saleMan" title="业务员" width="100"></vxe-table-column>
        <vxe-table-column field="createUser" title="创建人" width="100"></vxe-table-column>
        <vxe-table-column field="createTime" title="创建时间" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          style="margin-top: 20px"
          background
          size="small"
          :current-page.sync="page1.currentPage"
          :page-size.sync="page1.pageSize"
          :total="page1.totalResult"
          @page-change="changePage1"
      ></vxe-pager>
    </div>
    <div class="add-box clearfix" v-show="tabVal === 'sub'">
      <vxe-table
          show-overflow
          stripe
          highlight-current-row
          border="none"
          class="table-style"
          ref="xTable2"
          max-height="450"
          :auto-resize="true"
          :loading="loading2"
          :data="orderListData"
          align="center"
          @current-change="currentChangeEvent2"
      >
        <vxe-table-column field="aboutAmount" title="关联金额" width="150"
                          v-if="!isEdit && !controlEdit"></vxe-table-column>
        <vxe-table-column field="ordersNumAttached" title="订单编号" min-width="130">
          <template slot-scope="{ row }">
            <a @click="openDetail(row.id)">{{ row.ordersNumAttached }}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="relOrdersNum" title="关联主订单" min-width="120" align="center">
          <template slot-scope="{ row }">
            <a @click="openOrderDetail(row.relOrdersId)">{{ row.relOrdersNum }}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="compName" title="所属公司" min-width="120"></vxe-table-column>
        <vxe-table-column field="ordersTypeText" title="订单类型" min-width="80" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.ordersTypeText }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="ordersTitleAttached" title="订单标题" width="150"></vxe-table-column>
        <vxe-table-column field="sellerName" title="销售方" width="200"></vxe-table-column>
        <vxe-table-column field="saleMan" title="业务员" min-width="100"></vxe-table-column>
        <vxe-table-column field="createUser" title="创建人" min-width="100"></vxe-table-column>
        <vxe-table-column field="createTime" title="创建时间" min-width="120">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          style="margin-top: 20px"
          background
          size="small"
          :current-page.sync="page2.currentPage"
          :page-size.sync="page2.pageSize"
          :total="page2.totalResult"
          @page-change="changePage2"
      ></vxe-pager>
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import {isEmpty, isNotEmpty} from "@/utils/util";
import {numberToCurrency, numberToMoney} from "@/filters/type";
import auth from "@/utils/auth";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  name: "PaymentAboutOrder",
  mixins: [getAuthOrization],
  props: {
    isOnlyBuyer: Boolean,
    isEdit: {
      type: Boolean,
      default: true
    },
    controlEdit: {
      type: Boolean,
      default: false
    },
    isSub: {
      type: Boolean,
      default: false
    },
  },
  data() {
    let userInfoValue = {};
    if (auth.isLogin()) {
      userInfoValue = auth.getAuth();
    }
    return {
      userInfoValue,
      type: 0, //  0 - 线上 ,  1 - 线下
      tabVal: 'new',
      cate: "", // 选择的订单类型,  Collection 购买方订单  Payment SellerPayment 承运人订单
      platformCompanyId: "", //所属平台
      searchOrdersNum: "", //搜索订单号
      searchOrdersName: "", //搜索托运人 或 承运人 实际承运人 名称
      searchOrdersBuyer: "",
      searchOrdersCompName: "",
      searchOrdersSeller: "",
      searchOrdersCarShipNum: "",
      searchOrdersSaleMan: "",
      loading1: false,
      loading2: false,
      payAmount: 0,
      tableData: [],
      orderListData: [],
      isCheckboxAll: false,
      checkboxConfig: {
        labelField: "操作",
        checkField: "checked"
      },
      currentPage: 0,
      page1: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100
      },
      page2: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100
      },
      resMoneyMap: {},
      chainId: "",
      platformCompany: null,
      paymentsId: null,
      searchLoading: false,
      buyerNameOptions: [], // 搜索托运人下拉框
      sellerNameOptions: [],
      orderType: [],
      ordersNumAttached: null,
      ordersTitleAttached: null,
      searchComp: [],
      compOptions: [],
      searchSellerName: [],
      sellerOptions: [],
      searchSalesMan: [], // 搜索业务员字段
      salesManOptions: [], // 搜索业务员下拉框
    };
  },
  computed: {
    showCate() {
      return this.isOnlyBuyer ? false : true;
    }
  },
  created() {
    // this.getSelData();
    this.getDict(59000, 'orderType');
  },
  methods: {
    async getDict(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code,
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map((i) => {
          arr.push({
            label: i.dictText,
            value: i.dictCode,
          });
        });
        this[key] = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    openOrderDetail(id) {
      if (!this.isHavePermission("ordersTwo:detail")) {
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！",
        });
        return;
      }
      let obj = {
        name: `订单详情2.0-${id}`,
        path: `/order2/orderdetail/${id}`,
      };
      window.open(obj.path);
      return false;
    },
    init(
        type,
        cate,
        paymentsId,
        payAmount,
        ordersList,
        platformCompany,
        platformCompanyId,
        modalType
    ) {
      this.modalType = modalType;
      this.platformCompany = platformCompany;
      this.platformCompanyId = platformCompanyId;
      this.type = type;
      this.page1.currentPage = 1;
      this.tabVal = 'new';
      this.isCheckboxAll = false;
      this.cate = cate;
      this.paymentsId = isEmpty(paymentsId) ? 0 : paymentsId;
      this.payAmount = payAmount;
      this.ordersList = isEmpty(ordersList) ? [] : ordersList;
      this.searchOrdersNum = "";
      this.searchOrdersName = "";
      this.resMoneyMap = {};
      this.ordersList.forEach(item => {
        if (isNotEmpty(item.ordersId)) {
          item.checked = true;
          this.resMoneyMap[item.ordersId] = item;
        }
      });
      this.getOrderList();
      this.getSubOrder();
    },
    changePage1(e) {
      this.page1.pageSize = e.pageSize;
      this.page1.currentPage = e.currentPage;
      this.getOrderList();
    },
    changePage2(e) {
      this.page2.pageSize = e.pageSize;
      this.page2.currentPage = e.currentPage;
      this.getSubOrder();
    },
    search() {
      this.page1.currentPage = 1;
      this.getOrderList();
    },
    search2() {
      this.page2.currentPage = 1;
      this.getSubOrder();
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    async getList(query, options, url, path, columnType) {
      let params = {};
      if (this.tabVal === 'new') {
        params = {
          cate: columnType,
          name: query
        };
      } else {
        params = {
          columnType: columnType,
          keyword: query,
        };
      }
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].post(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        let data = res.data;
        this[options] = [];
        data.map((i, index) => {
          if (index < 10) {
            this[options].push(i)
          }
        })
      }
    },
    async getOrderList() {
      // 获取列表数据
      this.loading1 = true;
      // let platformCompanyIdList = [];
      // platformCompanyIdList.push(this.platformCompanyId);
      let params = {
        platformCompanyId: this.platformCompanyId,
        page: this.page1.currentPage,
        rows: this.page1.pageSize,
        orderBy: 2
      };
      let url = this.modalType === 'pay' && this.userInfoValue.identityType === 0 ? "selectRelatedMoneyListDataScope" : "selectRelatedMoneyList";
      if (this.paymentsId !== 0 && !this.controlEdit && !this.isEdit) {
        params.paymentsId = this.paymentsId;
        params.isShowOnly = 1;
        if (
            isEmpty(this.searchOrdersNum) &&
            isEmpty(this.searchOrdersName) &&
            isEmpty(this.searchOrdersBuyer) &&
            isEmpty(this.searchOrdersSeller) &&
            isEmpty(this.searchOrdersSaleMan) &&
            isEmpty(this.searchOrdersCarShipNum) &&
            this.ordersList.length > 0
        ) {
          url = this.modalType === 'pay' && this.userInfoValue.identityType === 0 ? "relatedMoneyListDataScope" : "relatedMoneyList";
        }
        // params.flowState = 0;
      }
      //   if (this.cate == "SellerPayment") {
      //     params.buyerName = this.platformCompany;
      //   } else {
      //     params.platformCompanyId = this.platformCompanyId;
      //   }
      //   //搜索的参数
      if (this.searchOrdersNum) {
        params.ordersNum = this.searchOrdersNum;
      }
      if (this.searchOrdersName) {
        params.ordersTitle = this.searchOrdersName;
      }
      if (this.searchOrdersBuyer) {
        params.buyerName = this.searchOrdersBuyer;
      }
      if (this.searchOrdersSeller) {
        params.sellerName = this.searchOrdersSeller;
      }
      if (this.searchOrdersCompName) {
        params.compName = this.searchOrdersCompName;
      }
      if (this.searchOrdersCarShipNum) {
        params.carShipNum = this.searchOrdersCarShipNum;
      }
      if (this.searchOrdersSaleMan) {
        params.saleMan = this.searchOrdersSaleMan;
      }

      let res = await $api.twoOrders.post(url, params);

      if (res.status != 1) {
        if (isEmpty(res.message)) res.message = "接口异常";
        this.$refs.$XModal.message(res.mesage);
        return;
      }

      let tableData = res.data.rows;
      this.isCheckboxAll = true;
      tableData.map(i => {
        if (
            isNotEmpty(this.resMoneyMap[i.id]) &&
            isNotEmpty(this.resMoneyMap[i.id].aboutAmount)
        ) {
          i.relatedAmount = this.resMoneyMap[i.id].aboutAmount;
          i.aboutAmount = i.relatedAmount;
        } else {
          i.aboutAmount = null;
        }

        if (isEmpty(i.aboutAmount)) {
          i.checked = false;
          this.isCheckboxAll = false;
        } else {
          i.checked = true;
        }
      });
      this.tableData = tableData;
      this.page1.totalResult = res.data.total;

      if (isNotEmpty(this.$refs.xTable1)) {
        tableData.forEach(row => {
          if (row.checked == true) {
            this.$refs.xTable1.setCheckboxRow(row, true);
          }
        });
      }
      this.loading1 = false;
    },
    async getSubOrder() {
      let params = {
        page: this.page2.currentPage,
        rows: this.page2.pageSize,
        orderBy: 2,
        ordersTitleAttached: this.ordersTitleAttached,
        ordersNumAttached: this.ordersNumAttached,
        platformCompanyIds: [],
      };

      if (this.searchSellerName.length > 0) {
        params.sellerIds = this.searchSellerName;
      }
      if (this.searchSalesMan.length > 0) {
        params.saleManIds = this.searchSalesMan;
      }
      if (this.searchComp.length > 0) {
        params.platformCompanyIds = this.searchComp;
      } else {
        params.platformCompanyIds.push(this.platformCompanyId);
      }

      this.loading2 = true;
      let res = await $api.twoOrders.post("getAttachedOrderList", params);
      this.loading2 = false;
      if (res.status === 1) {
        let pageData = res.data;
        this.orderListData = pageData.rows;
        this.orderType.map(i => {
          this.orderListData.map(j => {
            if (j.ordersType === i.value) {
              j.ordersTypeText = i.label;
            }
          })
        })
        this.page2.totalResult = pageData.total;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    currentChangeEvent1({row}) {
      let resAmountList = [];
      let usedAmount = 0;
      let paymentType;
      if (this.cate == "Collection") {
        paymentType = 1;
      } else if (this.cate == "Payment") {
        paymentType = 2;
      } else {
        paymentType = 3;
      }
      let obj = {
        id: row.id,
        ordersId: row.id,
        ordersNum: row.ordersNum,
        buyerName: row.buyerName,
        buyerId: row.buyerId,
        sellerName: row.sellerName,
        sellerId: row.sellerId,
        salesMan: row.saleMan,
        platformCompanyId: this.platformCompanyId,
        paymentType
      };
      resAmountList.push(obj);
      if (this.isEdit || this.controlEdit) {
        this.$emit("choose", resAmountList, usedAmount);
      }
    },
    currentChangeEvent2({row}) {
      let resAmountList = [];
      let usedAmount = 0;
      let paymentType;
      if (this.cate == "Collection") {
        paymentType = 1;
      } else if (this.cate == "Payment") {
        paymentType = 2;
      } else {
        paymentType = 3;
      }
      let obj = {
        id: row.id,
        ordersId: row.id,
        ordersNum: row.ordersNumAttached,
        salesMan: row.saleMan,
        salesManId: row.saleManId,
        platformCompanyId: this.platformCompanyId,
        settlementAmount: row.settlementAmount,
        paymentType
      };
      resAmountList.push(obj);
      if (this.isEdit || this.controlEdit) {
        this.$emit("choose", resAmountList, usedAmount, 'sub');
      }
    },
    openDetail(id) {
      let obj = {};
      obj.name = `附属订单详情${id}`
      obj.path = `/subOrder/orderdetail/${id}`
      window.open(obj.path);
    },
  }
};
</script>

<style scoped>
.vxe-pager .vxe-pager--wrapper {
  position: relative;
}

.vxe-pager .vxe-pager--sizes {
  height: 28px !important;
}

.modal-header {
  position: relative;
  height: 60px;
}

.my-search {
  padding: 10px;
  position: absolute;
  right: 0;
  top: 0;
}

.my-search >>> .ivu-select-selection {
  height: 34px;
  border-radius: 0;
}

.my-search >>> .ivu-icon-ios-arrow-down {
  position: absolute;
  right: 5px;
  top: 10px;
  color: #999;
  cursor: pointer;
}

.my-search .vxe-input {
  height: 34px;
  width: 400px;
  vertical-align: middle;
}

/*.my-search .vxe-input >>> .vxe-input--suffix {*/
/*  display: block !important;*/
/*  width: 60px;*/
/*  height: 32px;*/
/*  top: 1px;*/
/*  text-align: center;*/
/*  border-left: 1px solid #dcdfe6;*/
/*  background-color: #f5f7fa;*/
/*  cursor: pointer;*/
/*}*/

.my-search .vxe-input >>> .vxe-input--inner {
  border: 1px solid #dcdfe6;
}

.btn-down {
  border: none;
  background: transparent;
}

.btn-down:focus {
  outline: none;
  border-color: transparent;
  box-shadow: none;
}

.link-text {
  margin-right: 30px;
  margin-left: 10px;
}

/*.ivu-btn.ivu-btn-primary {*/
/*  width: 140px;*/
/*  height: 40px;*/
/*}*/

.choose-match-invoice .vxe-radio-group,
.choose-match-invoice .tab-list {
  width: 100%;
  box-sizing: border-box;
}

.choose-match-invoice .tab-list {
  border-bottom: 1px solid #dcdee2;
}

.choose-match-invoice .tab-list li {
  padding: 0 20px;
  margin-right: 0px;
}

.choose-match-invoice .my-search {
  margin-top: 10px;
  position: relative;
}
</style>